export const typeFileOptions = [
    { label: 'Все', value: 0 },
    { label: 'Видео', value: 1 },
    { label: 'Фото', value: 2 },
    { label: 'Аудио', value: 3 },
];

export const ratingOptions = [
    { label: '1 - наименьшая секретность', value: 0 },
    { label: '2 - низкая секретность', value: 1 },
    { label: '3 - средний уровень секретности', value: 2 },
    { label: '4 - повышенная секретность', value: 3 },
    { label: '5 - высокая секретность', value: 4 },
];

export const mockCities = ['City 1', 'City 2', 'City 3'];
export const mockStreets = ['Street 1', 'Street 2', 'Street 3'];

export type FormFileFiltrationValues = {
    fromDate?: moment.Moment;
    toDate?: moment.Moment;
    callsign?: string;
    serialNumber?: string;
    group?: string[];
    owner?: string[];
    city?: string[];
    street?: string[];
    fileType?: string;
    ratings?: number[];
    audioRoom?: string;
    messageType?: number;
    authorType?: number;
    operator?: string;
};
